import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { EXRLoader } from "three/addons/loaders/EXRLoader.js";

export default class Resources extends THREE.EventDispatcher {
  constructor(sources) {
    super();

    this.sources = sources;

    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;

    this.setLoaders();
    this.startLoading();

    // Emit initial progress so UI can start at 0%
    this.dispatchEvent({
      type: "progress",
      loaded: this.loaded,
      toLoad: this.toLoad,
      progress: this.toLoad === 0 ? 1 : 0,
    });
  }

  setLoaders() {
    this.loaders = {};
    this.loaders.gltfLoader = new GLTFLoader();
    this.loaders.textureLoader = new THREE.TextureLoader();
    this.loaders.exrLoader = new EXRLoader();
  }

  startLoading() {
    // Load each source
    for (const source of this.sources) {
      if (source.type === "gltfModel") {
        this.loaders.gltfLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "texture") {
        this.loaders.textureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "exrTexture") {
        this.loaders.exrLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      }
    }
  }

  sourceLoaded(source, file) {
    this.items[source.name] = file;

    this.loaded++;

    // Emit progress on every loaded item
    this.dispatchEvent({
      type: "progress",
      loaded: this.loaded,
      toLoad: this.toLoad,
      progress: this.toLoad === 0 ? 1 : this.loaded / this.toLoad,
    });

    if (this.loaded === this.toLoad) {
      this.dispatchEvent({ type: "ready" });
    }
  }
}
